import styled from '@emotion/styled';

// Used to fix Cash Symbols using Wonderfull font
const CashSymbolFix = styled.span`
	font-size: 80%;
`;

export default CashSymbolFix;
